var map = {
	"./Bamboo.png": 67491,
	"./Bitbucket.png": 24204,
	"./Bitbucketcloud.png": 14937,
	"./Confluence.png": 14853,
	"./Confluencecloud.png": 91422,
	"./Flow.png": 583,
	"./Flow_old.png": 76029,
	"./GitLab.png": 8234,
	"./GitLabcloud.png": 59763,
	"./Github.png": 64258,
	"./JFrog.png": 13211,
	"./Jenkins.png": 22865,
	"./Jira.png": 90859,
	"./Jiracloud.png": 73712,
	"./MariaDB.png": 20643,
	"./Nexus.png": 10954,
	"./NexusIQ.png": 65148,
	"./Scan.png": 10932,
	"./SonarQube.png": 63679,
	"./toolsDefault.png": 94107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67628;